import { Form, Upload, message } from 'antd';
import type {
  RcFile,
  UploadChangeParam,
  UploadFile,
} from 'antd/es/upload/interface';
import cn from 'classnames';
import { FC, ReactNode, useEffect, useState } from 'react';
import { Icon } from '@/components';
import { getUpload } from '@/services/api/upload';
// import { getFileIcon } from '../FileComponent/index';
import styles from './index.less';

const beforeUpload = (file: RcFile, maxSize: number, accept: string) => {
  const fileFormat = file?.name.slice(file?.name.lastIndexOf('.') + 1);
  const isPass = accept.includes(fileFormat?.toLocaleLowerCase());
  if (!isPass) {
    message.error('不支持上传该格式文件！');
  }
  const isLt5M = file.size / 1024 / 1024 < maxSize;
  if (!isLt5M) {
    message.error(`文件必须小于${maxSize}M！`);
  }
  return isPass && isLt5M;
};

const CustomUpload: FC<{
  name: string;
  rules?: any[];
  tip?: string | ReactNode;
  accept?: string;
  maxSize?: number;
  required?: boolean;
  maxCount?: number;
  multiple?: boolean;
  className?: string;
  uploadClass?: string;
  tipClass?: string;
  label: string | ReactNode;
}> = ({
  name,
  label,
  rules,
  tipClass,
  className,
  uploadClass,
  maxSize = 5,
  maxCount = 1,
  multiple = false,
  required = true,
  accept = '.jpg,.jpeg,.png',
  tip = '支持.jpg/.jpeg/.png格式，单个文件小于5M，最多5张',
}) => {
  const [fileList, setFileList] = useState<RcFile[]>([]);
  const form = Form.useFormInstance();
  const val = form.getFieldValue(name) || [];

  useEffect(() => {
    setFileList(val);
  }, []);

  const updateValue = (fileList: any[]) => {
    form.setFieldsValue({
      [name]: fileList,
    });
    setFileList(fileList);
  };

  const handleChange = ({
    file,
    fileList,
  }: UploadChangeParam<UploadFile<any>>) => {
    if (file?.status === 'removed') updateValue(fileList);
  };

  const uploadImg = async (option: any) => {
    const { file } = option;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('pathEnum', 'MALL_REST');
    try {
      const { data, errorMessage, success } = await getUpload(formData);
      if (!success) return message.error(errorMessage);
      if (maxCount === 1) {
        updateValue([
          {
            uid: file.uid,
            status: 'done',
            url: data?.url,
            response: errorMessage,
            name: data?.oriFileName,
          },
        ]);
        return;
      }
      if (fileList?.length >= maxCount) {
        message.error(`最多上传${maxCount}张图片`);
        return;
      }
      updateValue([
        ...val,
        {
          uid: file.uid,
          status: 'done',
          url: data?.url,
          response: errorMessage,
          name: data?.oriFileName,
        },
      ]);
    } finally {
      // setUploading(false);
    }
  };

  const showUpload = fileList?.length < maxCount;

  return (
    <Form.Item
      name={name}
      label={label}
      rules={rules}
      className={className}
      required={required}
    >
      <Upload
        fileList={fileList}
        multiple={multiple}
        maxCount={maxCount}
        data={{
          pathEnum: 'MALL_REST',
        }}
        listType="picture-card"
        onChange={handleChange}
        customRequest={uploadImg}
        className={uploadClass}
        beforeUpload={(file) => beforeUpload(file, maxSize, accept)}
        // iconRender={(file) => {
        //   return getFileIcon(file?.name);
        // }}
      >
        {showUpload && (
          <div
            className={cn('flex flex-col items-center gap-y[2px]', uploadClass)}
          >
            <div>
              <Icon
                className="text-[#999999] text-[26px]"
                type="icon-icon_uploading"
              />
            </div>
            <div className="text-[12px]">
              <span className="text-[#333333]">{fileList?.length}</span>
              <span className="text-[#999999]">/{maxCount}</span>
            </div>
          </div>
        )}
      </Upload>
      <div className={cn(styles.uploadTip, tipClass)}>{tip}</div>
    </Form.Item>
  );
};

export default CustomUpload;
